import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';

import useItemCoupon from './hooks/useItemCoupon';
import { DiscountRowProps } from './types';

function DiscountItemRow({ item, coupon }:DiscountRowProps) {
    const { itemName, thumbnailImage, idx } = item;
    const {
        isSelected, selectCoupon, selectedCoupon, disabled,
    } = useItemCoupon({ item, coupon });
    return (
        <Container onClick={selectCoupon} disabled={disabled}>
            <Checkbox style={{ padding: 0, width: 24 }}
                isChecked={isSelected} />
            <Thumbnail src={thumbnailImage}
                width={32}
                height={32}
                alt={itemName} />
            <Column>
                <Text>
                    {itemName}
                </Text>
                {selectedCoupon && (
                    <CouponBadge>
                        <Text size='xs'>{selectedCoupon?.couponName}</Text>
                    </CouponBadge>
                )}

            </Column>
        </Container>
    );
}

const Container = styled('div', {
    shouldForwardProp: (prop) => prop !== 'disabled',
})<{
    disabled?: boolean;
}>`
    padding: 16px;
    background-color: var(--color-gray1);
    border-radius: 8px;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

const CouponBadge = styled.div`
    background-color: white;
    padding: 2px 4px;
    border-radius: 4px;
`;

const Thumbnail = styled(Image)`
    object-fit: cover;
    border-radius: 4px;
`;

export default DiscountItemRow;
